import React from 'react'

const Loader = ({style, className, loaderStyle}) => {
    return (
        <div
            className={`position-absolute w-100 bg-white ${className}`}
            style={{...style, zIndex: "100000", height: "70px"}}
        >
            <div className="loader bg-white" style={{...loaderStyle}}></div>
        </div>
    )
};

export default Loader;